import React from 'react';
import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
import TextLabel from '../textLabel/textLabel';
import { dataHooks } from './constants';

var GooglePreview = function GooglePreview(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.getClassName('control-google-preview'),
    "data-aid": props.automationId,
    "data-hook": props.dataHook
  }, /*#__PURE__*/React.createElement("div", {
    className: "preview-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React.createElement(TextLabel, {
    dataHook: dataHooks.title,
    value: props.title,
    shouldTranslate: props.shouldTranslate
  })), /*#__PURE__*/React.createElement("div", {
    className: "url"
  }, /*#__PURE__*/React.createElement(TextLabel, {
    dataHook: dataHooks.url,
    value: props.url,
    shouldTranslate: props.shouldTranslate
  })), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, /*#__PURE__*/React.createElement(TextLabel, {
    dataHook: dataHooks.description,
    value: props.description,
    shouldTranslate: props.shouldTranslate,
    enableEllipsis: false
  }))));
};

GooglePreview.displayName = 'GooglePreview';
GooglePreview.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /**
   * Automation ID - for testing purposes, please use dataHook instead
   * @deprecated
   */
  automationId: PropTypes.string,

  /** Ad title */
  title: PropTypes.string.isRequired,

  /** Ad url */
  url: PropTypes.string.isRequired,

  /** Ad description */
  description: PropTypes.string.isRequired
};
export default compose(GooglePreview);